import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';
import { NoWeightName, WeightMap } from 'common/post/PostVotes/Constants';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsVoteObjectBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The vote object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the vote.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'The board this vote is associated with.',
                heading: 'board',
                subheading: 'Board object',
              },
              {
                description:
                  'The admin who cast this vote on behalf of a user. If the user voted themselves, this field will be null.',
                heading: 'by',
                subheading: 'User object',
              },
              {
                description: 'Time at which the vote was first cast, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'The post this vote is associated with.',
                heading: 'post',
                subheading: 'Post object',
              },
              {
                description: 'The user this post is associated with.',
                heading: 'voter',
                subheading: 'User object',
              },
              {
                description: `The priority of the vote. Can be one of ${Object.entries(WeightMap)
                  .map(([index, weight]) => `"${weight.name}"`)
                  .join(', ')}, or "${NoWeightName}".`,
                heading: 'votePriority',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example vote object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba123b",
  "board": {
    "created": "2017-08-30T13:32:01.000Z",
    "id": "553c3ef8b8cdcd1501ba4400",
    "name": "Feature Requests",
    "postCount": 99,
    "url": "https://your-company.canny.io/admin/board/feature-requests"
  },
  "by": null,
  "created": "2017-08-30T13:32:01.000Z",
  "post": {
    "category": {
      "id": "553c3ef8b8cdcd1501ba2234",
      "name": "Dashboard",
      "postCount": 42,
      "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
    },
    "commentCount": 2,
    "id": "553c3ef8b8cdcd1501ba4444",
    "imageURLs": [],
    "jira": {
      "linkedIssues": [{
        "id": "123",
        "key": "ID-123",
        "url": "https://your-company.atlassian.net/browse/ID-123"
      }]
    },
    "linear": {
      "linkedIssueIDs": ["ID-123", "ID-345"],
    },
    "score": 13,
    "status": "planned",
    "tags": [{
      "id": "553c3ef8b8cdcd1501ba2234",
      "name": "iOS",
      "postCount": 15,
      "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
    }],
    "title": "post-title",
    "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
  },
  "voter": {
    "id": "553c3ef8b8cdcd1501ba123a",
    "created": "2017-08-30T13:32:00.000Z",
    "email": "test@test.test",
    "isAdmin": false,
    "name": "Sally Doe",
    "url": "https://your-company.canny.io/admin/users/sally-doe",
    "userID": "1234"
  },
  "zendeskTicket": {
      "url": "https://your-company.zendesk.com/api/v2/tickets/2.json",
      "id": 2,
      "created": "2018-12-14T19:20:25Z",
      "subject": "Ticket subject",
      "description": "Ticket description",
  },
  "votePriority": "No priority",
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
